module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.tab_selected_energy && !_vm.analyzers_status && !_vm.generator_status && !_vm.pump_status) ? _c('GeneralSpinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-select-style col-md-12 mb-12"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill"
  }, [(_vm.analyzers_status) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_analyzer
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('analyzer')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.electric_params) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.generator_status) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_generator
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('generator')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.generator) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.pump_status) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_pump
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('pump')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.pump_well) + "\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-12"
  }, [(_vm.tab_selected_analyzer) ? _c('div', [_c('AnalyzerStatus', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : (_vm.tab_selected_generator) ? _c('div', [_c('GeneratorStatus', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : (_vm.tab_selected_pump) ? _c('div', [_c('PumpStatus', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : (_vm.tab_selected_energy) ? _c('div', [_c('EnergyCounters', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d879f86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 547
// module chunks = 1